import { PaymentPayload } from 'components/Sell/payment/hook/usePaymentDialog'
import { usePOSCFDHubContext } from 'hooks/usePOSHubContext/usePOSHubContext'
import { CFDClientMessageType } from 'pages/CustomerFacingDisplayPage/reducer/Interface'
import { useCallback } from 'react'
import { useSaleDependenciesContext } from 'views/Sale/contexts/SaleDependenciesContext'
export const useSendPaymentToCFD = () => {
    const { cfdSetting } = useSaleDependenciesContext()
    const { onSendMessageToCFS } = usePOSCFDHubContext()

    const sendAwaitingPaymentToCFS = useCallback(
        (total: number, payment: PaymentPayload) => {
            if (!cfdSetting) return
            onSendMessageToCFS({
                type: CFDClientMessageType.Payment,
                payload: {
                    accountBalance: payment.accountBalance,
                    accountName: payment.accountName,
                    paymentTypeID: payment.paymentTypeID,
                    totaldue: total,
                },
            })
        },
        [cfdSetting, onSendMessageToCFS],
    )
    const sendQRToCFS = useCallback(
        (
            total: number,
            qrImageUrl: string,
            accountName: string,
            paymentTypeID: number,
        ) => {
            if (!cfdSetting) return

            onSendMessageToCFS({
                type: CFDClientMessageType.Payment,
                payload: {
                    totaldue: total,
                    accountName: accountName,
                    image: qrImageUrl,
                    paymentTypeID: paymentTypeID,
                    message: 'Please Scan this QR code to finish your payment',
                },
            })
        },
        [cfdSetting, onSendMessageToCFS],
    )
    const sendCompletePayment = useCallback(
        (changeAmount?: number, email?: string) => {
            if (!cfdSetting) return

            onSendMessageToCFS({
                type: CFDClientMessageType.FinishPayment,
                payload: {
                    isSuccessful: true,
                    changeAmount: changeAmount,
                    email: email ?? '',
                    message: cfdSetting?.thankYouMessage ?? '',
                },
            })
        },
        [cfdSetting, onSendMessageToCFS],
    )

    return {
        onSendMessageToCFS,
        sendQRToCFS,
        sendCompletePayment,
        sendAwaitingPaymentToCFS,
    }
}

export default useSendPaymentToCFD
